import { css } from '@emotion/react'
import { HTMLAttributes } from 'react'

export interface ContentContainerProps extends HTMLAttributes<HTMLDivElement> {
	isDeleted?: boolean
}

export default function ContentContainer({ isDeleted = false, ...props }: ContentContainerProps) {
	return (
		<div
			css={css`
				${isDeleted && deletedStyle}
			`}
			{...props}
		></div>
	)
}

const deletedStyle = css`
	width: fit-content;
	padding: 0.25rem 0.5rem;
	gap: 0.625rem;
	border-radius: 0.375rem;
	background: var(--bg-on-body-2, #f0f3f5);
	color: var(--tint-secondary, #808080);
	font-size: 0.875rem;
	line-height: 1.25rem;
`
